// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImagesBlock_wrapper__CYzkR","imagesBlock":"ImagesBlock_imagesBlock__4sFca","imgItem":"ImagesBlock_imgItem__ghgR2","img":"ImagesBlock_img__OzEt_"};